import Loader from "../../../components/Loader/Loader";
import Form from "../../../components/Form/Form";
import React, { useEffect, useState } from "react";
import Input from "../../../components/Input/Input";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";
import { useUserStore } from "../../../contexts/userStore";
import { ReaderModel, ReaderModelEnum } from "../../../constants/readers-model";
import ReadersService from "../../../services/ReadersService";
import { IoAlertCircleOutline } from "react-icons/io5";
import { useSSEContext } from "../../../contexts/sse";

export function ConfigAlphadigi(props) {
   const [showLoader, setShowLoader] = useState(false);
   const [port, setPort] = useState();
   const [enabled, setEnabled] = useState(false);
   const { selectedCondominio, selectedLicenceId } = useUserStore();
   const [status, setStatus] = useState();
   const { sseReceived } = useSSEContext();

   function updateConfig(config) {
      setPort(config.port ?? 5004);
      setEnabled(config.enabled);
      setStatus(config?.status);
   }

   useEffect(() => {
      if (sseReceived?.action === 'serviceConfigUpdate' && sseReceived?.content?.model === ReaderModelEnum.AlphaDigi) {
         updateConfig(sseReceived.content);
      }
   }, [sseReceived]);

   async function fetchConfig() {
      const response = await ReadersService.getReaderServiceConfig(ReaderModelEnum.AlphaDigi, selectedCondominio, selectedLicenceId);
      const config = response.data;
      updateConfig(config);
   }

   useEffect(() => {
      if (selectedCondominio) {
         fetchConfig();
      }
   }, [selectedCondominio]);

   async function handleSubmit(event) {
      event.preventDefault();
      const payload = {
         port,
         enabled,
         configuration: {}
      }
      await ReadersService.updateReaderServiceConfig(ReaderModelEnum.AlphaDigi, selectedCondominio, selectedLicenceId, payload);
   }

   return (
      <React.Fragment>
         {showLoader ? (
            <Loader />
         ) : (
            <Form
               handleSubmit={handleSubmit}
               type={props.type}
               navigateCancelUrl="../consulta-readers"
            >
               {status === 'notSynced' && (
                  <div className='alert alert-warning'>
                     <IoAlertCircleOutline size={20} />
                     <span><b>Atenção:</b> O serviço para os dispositivos {ReaderModel.AlphaDigi.name} não está sincronizado com o equipamento, os eventos do dispositivo não serão recebidos e processados!</span>
                     <a href="void(0)" onClick={e => handleSubmit(e)}>Sincronizar</a>
                  </div>
               )}
               {status != null && !['notSynced', 'synced'].includes(status) && (
                  <div className='alert alert-danger'>
                     <IoAlertCircleOutline size={20} />
                     <span><b>Atenção:</b> A sincronização do serviço para os dispositivos {ReaderModel.AlphaDigi.name} registrou um erro, os eventos do dispositivo não serão recebidos e processados!</span>
                     <a href="void(0)" onClick={e => handleSubmit(e)}>Sincronizar</a>
                  </div>
               )}
               <div className="grid grid-cols-2 w-full gap-3">
                  <Input
                     name="port"
                     id="port"
                     type="number"
                     labelText="Porta de Serviço TCP"
                     value={port}
                     onChange={({ target }) => setPort(target.value)}
                     required={true}
                  />
                  <ToggleButton
                     style={{ width: 'fit-content', paddingTop: '15px' }}
                     label={`Habilitado`}
                     onChange={(e) => setEnabled(e.target.checked)}
                     selected={enabled}
                  />
               </div>
            </Form>
         )}
      </React.Fragment>
   );
}